import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { APICore } from "../helpers/api/apiCore";

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ element: Component, roles, ...rest }: any) => {
  const api = new APICore();
  const location = useLocation();

  // Verificar si el usuario está autenticado
  const isAuthenticated = api.isUserAuthenticated();

  // Si no está autenticado, redirigir a /auth/login
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} />;
  }

  // Verificar el rol del usuario autenticado
  const loggedInUser = api.getLoggedInUser();

  if (roles && roles.indexOf(loggedInUser.role) === -1) {
    return <Navigate to="/" />;
  }

  // Si todo está bien, renderizar el componente
  return Component;
};

export default PrivateRoute;


